<div class="swiper-container" [swiper]="config" [(index)]="index">
  <div class="swiper-wrapper">

    <div class="swiper-slide" fxLayout="column" fxLayoutAlign="space-between center"
         *ngFor="let powerplant of productionSites">
      <div class="carousel-header" fxFlex="1 0 50px" fxLayout="row" fxLayoutAlign="center center">
        {{powerplant.name}}
      </div>

      <div class="crop" fxFlex="1 0 auto">
        <img [src]="getPicturePath(powerplant.id)"
             [rspPlaceholder]="defaultImage" alt="Produktionsstätte">
      </div>


      <div *ngIf="powerplant.detailText" class="carousel-detail" fxFlex="1 0 50px" fxLayout="row"
           fxLayoutAlign="center center">
        <span>{{powerplant.detailText}}</span>
      </div>

      <mat-divider *ngIf="hasKennzahlen(powerplant)"></mat-divider>

      <rsp-kennzahl *ngIf="hasKennzahlen(powerplant)" [kennzahlen]="powerplant.keyValuess"
                    style="width:100%"></rsp-kennzahl>

      <!-- <mat-divider *ngIf="powerplant.keyValuess.length > 0"></mat-divider>-->
    </div>
  </div>

  <div class="swiper-pagination"></div>
</div>
